import type { NavContentNavItems } from '@backstage/plugin-app-react';

import { Icon } from '@iconify/react';
import { SidebarDivider, SidebarSpacer, Sidebar as SidebarUI } from '@ipen/components';

import {
  BackstageCatalogNavigationItem,
  BackstageCommunityNavigation,
  BackstageNavigationItem,
  BackstageSidebarLogo,
  BackstageSidebarSearchModal,
  BackstageUserProfile,
} from './components';

export const Sidebar = ({ navItems }: { navItems: NavContentNavItems }) => {
  const home = navItems.take('page:home');
  const catalog = navItems.take('page:catalog');
  const assets = navItems.take('page:assets');
  const solutionMarketplace = navItems.take('page:ipen-foo/solution-marketplace');

  return (
    <SidebarUI
      aria-label="sidebar nav"
      headerBrand={<BackstageSidebarLogo />}
    >
      <BackstageSidebarSearchModal />
      <SidebarDivider />
      {home && (
        <BackstageNavigationItem {...home} icon={<Icon icon="ri:home-5-line" />} />
      )}
      {solutionMarketplace && (
        <BackstageNavigationItem {...solutionMarketplace} />
      )}
      {catalog && (
        <BackstageCatalogNavigationItem
          href={catalog.href}
          icon={<Icon icon="ri:folder-chart-line" />}
          title="Data Catalog"
        />
      )}
      <BackstageNavigationItem
        href="/ipen-apps"
        icon={<Icon icon="ri:apps-2-line" />}
        title="iPEN Apps"
      />
      <BackstageCommunityNavigation />
      {assets && <BackstageNavigationItem {...assets} />}
      <BackstageNavigationItem
        href="/docs"
        icon={<Icon icon="ri:folder-line" />}
        title="iPEN Wiki"
      />
      <SidebarSpacer />
      <SidebarDivider />
      <BackstageNavigationItem
        href="/report-incident"
        icon={<Icon icon="ri:alert-line" />}
        title="Report Incident"
      />
      <BackstageNavigationItem
        href="/create/templates/default/ipen-demand-new"
        icon={<Icon icon="ri:lightbulb-line" />}
        title="Submit Demand"
      />
      <SidebarDivider />
      <BackstageUserProfile />
    </SidebarUI>
  );
};
